var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6H7.5V10.5H16.5V6Z",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20.25V3.75C19.5 3.33579 19.1642 3 18.75 3L5.25 3C4.83579 3 4.5 3.33579 4.5 3.75L4.5 20.25C4.5 20.6642 4.83579 21 5.25 21H18.75C19.1642 21 19.5 20.6642 19.5 20.25Z",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 14.625C8.66421 14.625 9 14.2892 9 13.875C9 13.4608 8.66421 13.125 8.25 13.125C7.83579 13.125 7.5 13.4608 7.5 13.875C7.5 14.2892 7.83579 14.625 8.25 14.625Z",
    fill: "#2C3B60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.625C12.4142 14.625 12.75 14.2892 12.75 13.875C12.75 13.4608 12.4142 13.125 12 13.125C11.5858 13.125 11.25 13.4608 11.25 13.875C11.25 14.2892 11.5858 14.625 12 14.625Z",
    fill: "#2C3B60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.625C16.1642 14.625 16.5 14.2892 16.5 13.875C16.5 13.4608 16.1642 13.125 15.75 13.125C15.3358 13.125 15 13.4608 15 13.875C15 14.2892 15.3358 14.625 15.75 14.625Z",
    fill: "#2C3B60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 18.375C8.66421 18.375 9 18.0392 9 17.625C9 17.2108 8.66421 16.875 8.25 16.875C7.83579 16.875 7.5 17.2108 7.5 17.625C7.5 18.0392 7.83579 18.375 8.25 18.375Z",
    fill: "#2C3B60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.375C12.4142 18.375 12.75 18.0392 12.75 17.625C12.75 17.2108 12.4142 16.875 12 16.875C11.5858 16.875 11.25 17.2108 11.25 17.625C11.25 18.0392 11.5858 18.375 12 18.375Z",
    fill: "#2C3B60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 18.375C16.1642 18.375 16.5 18.0392 16.5 17.625C16.5 17.2108 16.1642 16.875 15.75 16.875C15.3358 16.875 15 17.2108 15 17.625C15 18.0392 15.3358 18.375 15.75 18.375Z",
    fill: "#2C3B60"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/Calculator.25a3e2c66b292ca645f629c238090a15.svg";
export { ForwardRef as ReactComponent };